import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'
import { ContactDataTechnical, contactDataTechnicalConverter } from '../contact-box.module'

@Injectable({ providedIn: 'root' })
export class ContactBoxTechnicalConverter extends CmsConverterService<ContactBoxTechnicalData> {
  convertData (source: CmsComponent) {
    const contactData = source?.otherProperties?.formData?.st_contact?.value?.[0]?.otherProperties?.formData ?? {}
    return {
      contactData: contactDataTechnicalConverter(contactData)
    }
  }
}

export const CONTACT_BOX_TECHNICAL_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ContactBoxTechnicalData>>(
  'ContactBoxTechnicalConverter')

export interface ContactBoxTechnicalData extends ConvertedComponentData {
  contactData: ContactDataTechnical;
}
